(() => {
  const OPTIONS_SELECTOR = '.product-sticky-bar__options';
  const syncSelectedState = (input) => {
    document
      .querySelectorAll(`${OPTIONS_SELECTOR} input[data-option-position]`)
      .forEach((stickyBarInput) => {
        if (stickyBarInput.name !== input.name) {
          return;
        }
        const label = stickyBarInput.nextElementSibling;

        if (label) {
          label.classList.toggle('is-selected', stickyBarInput.value === input.value);
        }
      });
  };

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.hasAttribute('data-option-position')) {
      syncSelectedState(input);
    }
  });

  document.addEventListener(
    'product:rerender',
    (event) => {
      const htmlFragment = event.detail?.htmlFragment;
      if (!htmlFragment) {
        return;
      }
      document.querySelectorAll('product-sticky-bar').forEach((stickyBar) => {
        const incomingStickyBar = htmlFragment.querySelector(
          `product-sticky-bar[form="${stickyBar.getAttribute('form')}"]`
        );
        if (!incomingStickyBar) {
          return;
        }
        incomingStickyBar.classList.toggle('is-visible', stickyBar.classList.contains('is-visible'));
        const focusedElement = document.activeElement;
        if (focusedElement?.id && stickyBar.contains(focusedElement)) {
          const focusedElementId = focusedElement.id;
          queueMicrotask(() => {
            const elementToFocus = document.getElementById(focusedElementId);
            if (elementToFocus && document.activeElement !== elementToFocus) {
              elementToFocus.focus({ preventScroll: true });
            }
          });
        }
      });
    },
    true
  );
})();